/** Route-kind styling in one place (sibling of slotTypeDisplay.ts); stand-by is slate because it is deliberately not work. */
import type { RouteKind } from "@/types/collections"

/** Row treatment for this kind; "" for operational and external so it composes with caller classes. */
export function getRouteKindRowClasses(routeKind: RouteKind): string {
  return [getRouteKindRowBgClasses(routeKind), getRouteKindAccentClasses(routeKind)]
    .filter(Boolean)
    .join(" ")
}

/**
 * Row tint without the accent: in tables shadcn's `[&_tr:last-child]:border-0` strips the last row's
 * border, so the accent goes on the first cell instead (see getRouteKindAccentClasses).
 */
export function getRouteKindRowBgClasses(routeKind: RouteKind): string {
  return routeKind === "standby" ? "bg-slate-200/80" : ""
}

/** Left accent bar: on the row for div rows, on the first cell inside a table. */
export function getRouteKindAccentClasses(routeKind: RouteKind): string {
  return routeKind === "standby" ? "border-l-4 border-l-slate-500" : ""
}

export function getRouteKindLaneClasses(routeKind: RouteKind): string {
  return routeKind === "standby" ? "bg-slate-200/60" : ""
}

/**
 * Stop styling keyed off the route, not the stop: stand-by route stops are often typed
 * depot_injection/internal_stop, so `stand_by` as a slot type is only a row label.
 */
export function getRouteKindStopClasses(routeKind: RouteKind): string {
  return routeKind === "standby"
    ? "stop-standby border-dashed border-slate-400 shadow-none"
    : ""
}

/** Sentence case, nowrap and shrink-0 so the badge fits the list's narrow code column on one line. */
export const ROUTE_KIND_BADGE_CLASSES =
  "inline-flex shrink-0 items-center whitespace-nowrap rounded-full border " +
  "border-slate-300 bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium leading-none text-slate-600"

/** Kind pill in the Status column: same geometry as the status pill beside it. Kind is a separate axis from status. */
export const ROUTE_KIND_PILL_CLASSES =
  "inline-flex shrink-0 items-center whitespace-nowrap rounded border " +
  "border-slate-300 bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600"

export function getRouteKindBadge(routeKind: RouteKind): string | null {
  return routeKind === "standby" ? "Stand-by" : null
}
